"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var logistics = _interopRequireWildcard(require("@/api/logistics"));
var customerOrderApi = _interopRequireWildcard(require("@/api/customerOrderApi.js"));
var _throttle = _interopRequireDefault(require("@/utils/throttle"));
var pintuanApi = _interopRequireWildcard(require("@/api/pintuanApi"));
var toolUtils = _interopRequireWildcard(require("@/utils/toolUtils.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      loading: false,
      visible: false,
      goodsId: '',
      pram: {},
      initloading: false,
      addresData: [],
      cosotmerOption: [],
      // 归属客户
      userLists: [],
      qrCode: null
    };
  },
  mounted: function mounted() {
    this.getCityList();
  },
  methods: {
    throttle: _throttle.default,
    openInit: function openInit(id, isSelfPickup) {
      var _this = this;
      this.initloading = true;
      setTimeout(function () {
        _this.initloading = false;
      }, 1000);
      this.searchCusotmer();
      this.qrCode = null;
      this.pram = {
        isSelfPickup: isSelfPickup,
        goodsId: id
      };
      this.visible = true;
    },
    handerSubmit: function handerSubmit() {
      var _this2 = this;
      var _ref = this.pram || {},
        uid = _ref.uid,
        customerId = _ref.customerId,
        _ref$areaList = _ref.areaList,
        areaList = _ref$areaList === void 0 ? [] : _ref$areaList,
        isSelfPickup = _ref.isSelfPickup,
        goodsId = _ref.goodsId,
        detail = _ref.detail,
        phone = _ref.phone,
        realName = _ref.realName;
      if (phone && !toolUtils.isPhoneNumber(phone)) {
        this.$message.warning('请输入正确的手机号！');
        return;
      }
      ;
      this.loading = true;
      var datas = {
        combinationId: goodsId,
        customerId: customerId,
        uid: uid
      };
      if (isSelfPickup == 1) {
        var _ref2 = areaList || [],
          _ref3 = _slicedToArray(_ref2, 3),
          province = _ref3[0],
          city = _ref3[1],
          district = _ref3[2];
        datas = _objectSpread(_objectSpread({}, datas), {}, {
          address: {
            province: province,
            city: city,
            district: district,
            detail: detail,
            phone: phone,
            realName: realName
          }
        });
      }
      ;
      pintuanApi.createPinStore(datas).then(function (data) {
        _this2.$message.success('操作成功');
        _this2.qrCode = data;
        _this2.loading = false;
      }).catch(function () {
        _this2.loading = false;
      });
    },
    closeRefresh: function closeRefresh() {
      this.visible = false;
      this.$emit('doRefresh');
    },
    closeEdit: function closeEdit() {
      this.visible = false;
    },
    getCityList: function getCityList() {
      var _this3 = this;
      this.addresData = [];
      logistics.treeLevel3().then(function (res) {
        _this3.addresData = res || [];
      });
    },
    // 归属客户
    searchCusotmer: function searchCusotmer(companyId) {
      var _this4 = this;
      this.cosotmerOption = [];
      customerOrderApi.getAllCustomer({
        companyId: companyId
      }).then(function (res) {
        _this4.cosotmerOption = res || [];
      });
    },
    searchUsers: function searchUsers(data) {
      var _this5 = this;
      this.throttle(function () {
        _this5.getUserList(data);
      }, 300)();
    },
    changeSelect: function changeSelect() {
      var _this$pram,
        _this$pram2,
        _this$pram3,
        _this6 = this;
      if (!((_this$pram = this.pram) !== null && _this$pram !== void 0 && _this$pram.customerId)) {
        this.userLists = [];
        return;
      }
      ;
      pintuanApi.checkCustomer({
        combinationId: (_this$pram2 = this.pram) === null || _this$pram2 === void 0 ? void 0 : _this$pram2.goodsId,
        customerId: (_this$pram3 = this.pram) === null || _this$pram3 === void 0 ? void 0 : _this$pram3.customerId
      }).then(function (res) {
        _this6.getUserList('');
      });
    },
    getUserList: function getUserList(keyword) {
      var _this7 = this;
      this.userLists = [];
      if (!this.pram.customerId) return;
      customerOrderApi.getUserByCustomer({
        customerId: this.pram.customerId,
        keyword: keyword
      }).then(function (res) {
        _this7.userLists = res;
      });
    },
    downloadQrcode: function downloadQrcode() {
      var base64Data = this.qrCode;
      // 去掉Base64字符串的前缀（即 'data:[<mediatype>][;base64],' 部分）
      var byteString = atob(base64Data.split(',')[1]);

      // 创建一个ArrayBuffer
      var arrayBuffer = new ArrayBuffer(byteString.length);
      var intArray = new Uint8Array(arrayBuffer);
      for (var i = 0; i < byteString.length; i++) {
        intArray[i] = byteString.charCodeAt(i);
      }

      // 创建一个Blob对象
      var blob = new Blob([arrayBuffer], {
        type: 'application/octet-stream'
      });

      // 创建一个指向Blob对象的URL
      var url = URL.createObjectURL(blob);

      // 创建一个<a>元素并设置其属性
      var a = document.createElement('a');
      a.href = url;
      a.download = '分享码.png'; // 设置下载文件的名称和扩展名

      // 将<a>元素添加到文档中（可选，只是为了确保元素存在）
      document.body.appendChild(a);

      // 触发点击事件以下载文件
      a.click();

      // 清理：移除<a>元素和URL对象
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    }
  }
};